import { MuiTheme, createStyles, makeStyles } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    headerBlock: {
      justifyContent: 'space-between',
      background: 'transparent',
      padding: '24px 40px',
      display: 'flex',
      height: '100px',
      alignItems: 'center',
      [theme.breakpoints.down('lg')]: {
        height: 'auto',
        flexDirection: 'column',
        gap: '20px',
        alignItems: 'baseline'
      },
      [theme.breakpoints.only('sm')]: {
        alignItems: 'flex-start'
      },
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        padding: '18px 20px 18px 20px',
        flexDirection: 'row',
        height: '100px'
      },
      [theme.breakpoints.only('xs')]: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0px',
        height: 'auto'
      }
    },
    headerText: {
      fontSize: '40px',
      fontWeight: 600,
      lineHeight: '1',
      [theme.breakpoints.only('xs')]: {
        fontSize: '32px'
      }
    },
    fieldLabel: {
      fontSize: '16px',
      fontWeight: 700
    },
    tableHeader: {
      lineHeight: '1.13',
      fontSize: '16px',
      fontWeight: 600
    }
  })
);
